"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M22 12c0-5.48-4.4-9.93-9.86-10-3.62-.05-6.85 2.03-8.71 5.14C.1 12.69 2.98 18.27 8 20.25v.25c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-.25c3.53-1.39 6-4.56 6-8.25m-2 0h-4V5.08c2.39 1.39 4 3.97 4 6.92m-6-7.74V12h-4V4.26c.64-.16 1.31-.26 2-.26s1.36.1 2 .26M4 12c0-2.95 1.61-5.53 4-6.92V12z"
}), 'RiceBowlRounded');